import { render, staticRenderFns } from "./ItemExtraDiscrepancy.vue?vue&type=template&id=0756e44a&"
import script from "./ItemExtraDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./ItemExtraDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports